export const selectAuthData = (state) => state?.auth?.authData || null

export const selectUserProfile = (state) => selectAuthData(state)?.result || null

export const selectUserId = (state) => {
  const profile = selectUserProfile(state)
  return profile?._id || profile?.googleId || null
}
